import { useState } from 'react';
import { colors } from 'ui/theme/colors';
import { Popover } from './Popover';
import { PopoverTrigger } from './PopoverTrigger';
import { PopoverPlacements } from './constants';
import { StyledHelpIcon, StyledPopoverContent } from './TogglePopover.styles';

export type POPOVER_PLACEMENT_TYPES =
  | PopoverPlacements.Top
  | PopoverPlacements.Bottom
  | PopoverPlacements.Right
  | PopoverPlacements.Left;

type TogglePopoverProps = {
  /** The placement string. Determines where the toolPopover will pop up. */
  placement?: POPOVER_PLACEMENT_TYPES;
  /** Content that shows up in the popover */
  popoverContentTitle: string | React.ReactNode;
  /** Content that shows up in the popover */
  popoverContentBody: string | React.ReactNode;
  /** Custom trigger component */
  PopoverTriggerComponent?: React.ComponentType<React.PropsWithChildren<unknown>>;
  /** Width of the trigger icon */
  iconWidth?: number;
  /** Height of the trigger icon */
  iconHeight?: number;
  /** Whether the toggle popover is being used in a modal */
  $isInModal?: boolean;
};

/** @deprecated use ClickTip instead */
export const TogglePopover: React.FC<React.PropsWithChildren<TogglePopoverProps>> = ({
  placement = PopoverPlacements.Top,
  popoverContentTitle = '',
  popoverContentBody = '',
  PopoverTriggerComponent = PopoverTrigger,
  children,
  iconWidth,
  iconHeight,
  $isInModal = false,
  ...props
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const [iconColor, setIconColor] = useState(colors.textSecondary);

  return (
    <Popover open={showPopover}>
      <StyledPopoverContent
        TitleContent={popoverContentTitle}
        side={placement}
        $isInModal={$isInModal}
        placement={placement}
        {...props}
      >
        {popoverContentBody}
      </StyledPopoverContent>
      <PopoverTriggerComponent asChild>
        <div
          onMouseEnter={() => {
            setShowPopover(true);
            setIconColor(colors.purple100);
          }}
          onMouseLeave={() => {
            setShowPopover(false);
            setIconColor(colors.textSecondary);
          }}
        >
          {children || <StyledHelpIcon color={iconColor} width={iconWidth} height={iconHeight} />}
        </div>
      </PopoverTriggerComponent>
    </Popover>
  );
};

/** @deprecated use TopClickTip instead */
export const TopTogglePopover: React.FC<React.PropsWithChildren<TogglePopoverProps>> = (props) => (
  <TogglePopover placement={PopoverPlacements.Top} {...props} />
);
/** @deprecated use BottomClickTip instead */
export const BottomTogglePopover: React.FC<React.PropsWithChildren<TogglePopoverProps>> = (
  props,
) => <TogglePopover placement={PopoverPlacements.Bottom} {...props} />;
/** @deprecated use RightClickTip instead */
export const RightTogglePopover: React.FC<React.PropsWithChildren<TogglePopoverProps>> = (
  props,
) => <TogglePopover placement={PopoverPlacements.Right} {...props} />;
/** @deprecated use LeftTogglePopover instead */
export const LeftTogglePopover: React.FC<React.PropsWithChildren<TogglePopoverProps>> = (props) => (
  <TogglePopover placement={PopoverPlacements.Left} {...props} />
);

export default TogglePopover;
